module.exports = __webpack_public_path__ + "img/sweden-eye-and-ear-diseases-female.4df74db5.png";